module.exports = __webpack_public_path__ + "static/img/tkb_logo.0a24f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tkb_logo.png
// module id = DH6b
// module chunks = 1